// @flow

import React from 'react';
import type { InputProps } from '../../../types';
import Radio from './radio';

type Props = {|
  input: {|
    ...InputProps,
    error: boolean,
    id: string,
    type: string,
  |},
|};

export default ({
  input,
}: Props) => (
  <Radio {...input} />
);
